<div class="header-container">
  <div class="row">
    <div class="bus-number-col col-lg-3 col-md-3 col-sm-3 col-xs-3">
      <mat-icon class="arrow-left-icon bus-icon" (click)="backClicked()"
        >keyboard_arrow_left</mat-icon
      >

      <h1
        *ngIf="!shapesList || (shapesList.features && !(shapesList.features.length > 0))"
        class="number-bus-header"
        [style]="'background-color: #' + color + ';'"
      >
        {{ busCode }}
      </h1>

      <h3
        *ngIf="!(!shapesList || (shapesList.features && !(shapesList.features.length > 0)))"
        class="number-bus-header"
        [style]="'background-color: ' + shapesList.features[0].properties.route_color + ';'"
      >
        {{ busCode }}
      </h3>
    </div>
    <div class="first-last-stop-col col-lg-9 col-md-9 col-sm-9 col-xs-9" style="padding-top: 3px">
      <div class="first-last-stop-row row" *ngIf="firstStop && lastStop">
        <div class="arrow-icon-col">
          <mat-icon class="direction-icon">arrow_right_alt</mat-icon>
        </div>
        <div class="first-last-stop-text-col" style="text-align: right">
          <h3 class="first-stop">{{ firstStop }}</h3>
          <h4 class="second-stop">
            {{ lastStop }}
          </h4>
        </div>
        <div class="swap-col">
          <mat-icon
            *ngIf="!shapesList || (shapesList.features && !(shapesList.features.length > 0))"
            class="change-dir-button"
            [style]="'color: #' + color + '; border: 2px solid #' + color + ';'"
            (click)="revertDirection()"
            >swap_vert</mat-icon
          >
          <mat-icon
            *ngIf="!(!shapesList || (shapesList.features && !(shapesList.features.length > 0)))"
            [style]="'color: #' + color + '; border: 2px solid #' + color + ';'"
            class="change-dir-button"
            (click)="revertDirection()"
            >swap_vert</mat-icon
          >
        </div>
      </div>
    </div>
  </div>
</div>
<div class="notices-showed" style="padding: 5px 20px 5px 20px">
  <button
    disabled="true"
    *ngFor="let notice of notices"
    [class]="'notices'"
    [style]="'border: 2px solid #eb4034;' + 'color: #353535; margin-bottom: 5px'"
    mat-stroked-button
    color="primary"
  >
    <span class="material-symbols-outlined"> bus_alert </span>
    <label>
      {{ notice.Texto }}
    </label>
  </button>
</div>
<div class="search-container">
  <mat-icon class="search-icon">search</mat-icon>
  <input
    class="text-input"
    type="text"
    [(ngModel)]="searchValue"
    autocomplete="off"
    placeholder="Buscar parada"
    (keyup)="setFilterValue()"
  />
  <button
    mat-button
    *ngIf="searchValue"
    matSuffix
    mat-icon-button
    aria-label="Clear"
    (click)="clearSearch()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
<div
  *ngIf="
    isVisibleSpinnerSearch || !stopsList || (stopsList.features && !(stopsList.features.length > 0))
  "
>
  <mat-spinner *ngIf="isVisibleSpinnerSearch"></mat-spinner>
  <div *ngIf="!isVisibleSpinnerSearch">
    <p style="padding: 15px">
      No se han encontrado resultados para tu búsqueda, intenta cambiar el sentido de la ruta.
    </p>
  </div>
</div>

<div
  *ngIf="
    !isVisibleSpinnerSearch &&
    !(!stopsList || (stopsList.features && !(stopsList.features.length > 0))) &&
    !(!shapesList || (shapesList.features && !(shapesList.features.length > 0)))
  "
>
  <!-- <div class="direction-indicator">
    <p>Dirección : {{ isReverseDirection ? "Vuelta" : "Ida" }}</p>
  </div> -->
  <div class="stops-div">
    <ul class="line">
      <li
        class="station station--default"
        *ngFor="
          let stop of stopsListFilter ? stopsListFilter : stopsList.features;
          let first = first;
          let last = last
        "
        (click)="goToTimesLines(stop)"
      >
        <div
          class="circle-shadow"
          [class.first]="first"
          [class.last]="last"
          [style]="
            'background-color: ' +
            shapesList.features[0].properties.route_color +
            ';' +
            'box-shadow: 0px 0px 0px 8px ' +
            shapesList.features[0].properties.route_color +
            ';'
          "
          *ngIf="first || last"
        ></div>
        <div
          class="circle"
          [class.first]="first"
          [class.last]="last"
          [style]="
            'background-color: ' +
            shapesList.features[0].properties.route_color +
            ';' +
            'border: 2px solid ' +
            shapesList.features[0].properties.route_color +
            '; left: -0.4em'
          "
          *ngIf="first || last"
        ></div>
        <div
          class="circle"
          [style]="'border: 4px solid ' + shapesList.features[0].properties.route_color + ';'"
          *ngIf="!first && !last"
        ></div>
        <p class="bus-lines-selector" [class.first]="first" [class.last]="last">
          {{ stop.properties.stop_name }} ({{ stop.properties.stop_code }})
        </p>
      </li>
    </ul>
  </div>
  <div class="direction-indicator" *ngIf="isVisibleDataSearchError">
    <p>No se han encontrado resultados para tu búsqueda.</p>
  </div>
</div>

<link
  rel="stylesheet"
  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
/>
